import { theme } from '@by-miles/bymiles-styles'
import styled from 'styled-components'

export const CoverBenefitStyles = styled.div`
  width: 100%;
  padding: 32px 24px; // theme file
  border-radius: 8px;
  background: ${theme.primaryColours.white.main};
  overflow: auto;
  @media (min-width: ${theme.grid.resolution.tablet.width}px) {
    width: ${theme.grid.resolution.tablet.container}px;
    margin: 0 auto;
  }

  @media (min-width: ${theme.grid.resolution.desktop.width}px) {
    width: ${theme.grid.resolution.desktop.container}px;
  }

  .inner-container {
    height: ${props => (props.open ? 'auto' : '365px')};
    position: relative;

    @media (min-width: ${theme.grid.resolution.tablet.width}px) {
      height: auto;
      display: grid;
      grid-template-columns: 1fr 1fr;
      grid-gap: 0 48px;

      .divider-wrapper {
          position: relative;
          &:after {
            content: ' ';
            position: absolute;
            width: 1px;
            height: 100%;
            background-color: ${theme.tints.aubergine};
            left: -24px;
            bottom: 0;
          }
        }
      }

      .inner-wrapper {
        position: relative;

        .container {
          margin-bottom: 32px;
          @media (min-width: ${theme.grid.resolution.tablet.width}px) {
            margin-bottom: 24px;
          }
        }
      }

      .info_icon {
        position: absolute;
        right: 0;
      }

      .container {
        width: 180px;
        @media (min-width: ${theme.grid.resolution.mobile.width}px) {
          width: 220px;
        }
        .info_icon {
          cursor: pointer;
        }
        @media (min-width: ${theme.grid.resolution.tablet.width}px) {
          width: 250px;
        }
        @media (min-width: ${theme.grid.resolution.desktop.width}px) {
          width: 300px;
        }
      }
    }

    ul {
      padding: 0;
      margin: 0;
      li {
        list-style: none;
        display: flex;
        gap: 8px;
        margin-bottom: 16px; // theme file
        color: ${theme.primaryColours.aubergine.main};
        .icon__tick {
          svg {
            position: relative;
            top: 2px;
          }
        }
      }
      &:nth-last-child(-n+2) :nth-last-child(1) {
        margin-bottom: 0;
      }
    }

    .heading {
      margin-top: 32px;
      margin-bottom: 8px;
      color: ${theme.primaryColours.aubergine.main};
      @media (min-width: ${theme.grid.resolution.tablet.width}px) {
        margin-bottom: 24px;
      }

      &:nth-child(1) {
        margin-top: 0;
      }
    }
  }

  .show-all {
    display: ${props => (props.open ? 'none' : 'flex')};
    justify-content: center;
    align-items: center;
    font-weight: bold;
    margin-top: 16px;
    cursor: pointer;
    color: ${theme.primaryColours.aubergine.main};
    height: 114px;
    width: 100%;
    position: absolute;
    bottom: 0;
    left: 0;
    background: -moz-linear-gradient(top,  rgba(255,255,255,0) 0%, rgba(255,255,255,1) 35%); /* FF3.6-15 */
    background: -webkit-linear-gradient(top,  rgba(255,255,255,0) 0%,rgba(255,255,255,1) 35%); /* Chrome10-25,Safari5.1-6 */
    background: linear-gradient(to bottom,  rgba(255,255,255,0) 0%,rgba(255,255,255,1) 35%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */

    @media (min-width: ${theme.grid.resolution.tablet.width}px) {
      display: none;
    }
    .see-all-text {
      position: absolute;
      bottom: 22px;
      width: 100%;
      text-align: center;
      display: flex;
      justify-content: center;
      .text {
        margin-right: 6px;
      }
    }
  }


  .electric-badge {
    background: ${theme.tints.mint};
    padding: 4px 8px;
    display: inline-block;
    margin-left: 24px;
    position: relative;
    top: -14px;
    &.desktop {
      display: none;
    }
    @media (min-width: ${theme.grid.resolution.desktop.width}px) {
      &.mobile {
        display: none;
      }
      &.desktop {
        display: block;
        position: absolute;
        right: 35px;
        top: initial;
      }
    }
  }
`
